export const ADD_TO_COMPARISON = 'ADD_TO_COMPARISON';
export const REMOVE_FROM_COMPARISON = 'REMOVE_FROM_COMPARISON';
export const UPDATE_COMPARISON_AT_POSITION = 'UPDATE_COMPARISON_AT_POSITION';
export const CLEAR_COMPARISON = 'CLEAR_COMPARISON';
export const TOGGLE_DRAWER_COLLAPSED = 'TOGGLE_DRAWER_COLLAPSED';

export const addToComparison = shingleUuid => ({
  type: ADD_TO_COMPARISON,
  payload: { shingleUuid },
});

export const removeFromComparison = shingleUuid => ({
  type: REMOVE_FROM_COMPARISON,
  payload: { shingleUuid },
});

export const clearComparison = () => ({
  type: CLEAR_COMPARISON,
});

export const updateComparisonAtPosition = (position, shingleUuid) => ({
  type: UPDATE_COMPARISON_AT_POSITION,
  payload: { position, shingleUuid },
});

export const toggleDrawerCollapsed = () => ({
  type: TOGGLE_DRAWER_COLLAPSED,
});
